import { api } from "../client";

export const deleteComplianceOverride = (id) => {
  return api.delete(`/ComplianceOverride/${id}`);
};
